/**
 * Route Constants
 * Centralized route definitions for the Uhamiaji SACCOS Management System
 */

export const ROUTES = {
  // Public Routes
  HOME: '/',
  PRIVACY_POLICY: '/privacy-policy',
  DOWNLOADS: '/downloads',
  
  // Dashboard
  DASHBOARD: '/dashboard',
  
  // Members Module
  MEMBERS: {
    ROOT: '/members',
    LIST: '/members',
    CREATE: '/members/create',
    EDIT: '/members/:id/edit',
    PROFILE: '/members/:id',
    DOCUMENTS: '/members/:id/documents',
  },
  
  // Loans Module
  LOANS: {
    ROOT: '/loans',
    LIST: '/loans',
    CREATE: '/loans/create',
    EDIT: '/loans/:id/edit',
    DETAILS: '/loans/:id',
    APPLICATIONS: '/loans/applications',
    APPROVALS: '/loans/approvals',
    DISBURSEMENTS: '/loans/disbursements',
  },
  
  // Savings Module
  SAVINGS: {
    ROOT: '/savings',
    LIST: '/savings',
    CREATE: '/savings/create',
    EDIT: '/savings/:id/edit',
    DEPOSIT: '/savings/deposit',
    WITHDRAWAL: '/savings/withdrawal',
    STATEMENT: '/savings/statement',
  },
  
  // Shares Module
  SHARES: {
    ROOT: '/shares',
    LIST: '/shares',
    CREATE: '/shares/create',
    PURCHASE: '/shares/purchase',
    STATEMENT: '/shares/statement',
  },
  
  // Repayments Module
  REPAYMENTS: {
    ROOT: '/repayments',
    LIST: '/repayments',
    CREATE: '/repayments/create',
    SCHEDULE: '/repayments/schedule',
    HISTORY: '/repayments/history',
  },
  
  // Guarantors Module
  GUARANTORS: {
    ROOT: '/guarantors',
    LIST: '/guarantors',
    CREATE: '/guarantors/create',
    EDIT: '/guarantors/:id/edit',
  },
  
  // Accounting Module
  ACCOUNTING: {
    ROOT: '/accounting',
    DASHBOARD: '/accounting',
    TRANSACTIONS: '/accounting/transactions',
    CHART_OF_ACCOUNTS: '/accounting/chart-of-accounts',
    JOURNAL_ENTRIES: '/accounting/journal-entries',
    LEDGERS: '/accounting/ledgers',
    TRIAL_BALANCE: '/accounting/trial-balance',
    INCOME_STATEMENT: '/accounting/income-statement',
    BALANCE_SHEET: '/accounting/balance-sheet',
  },
  
  // Reports Module
  REPORTS: {
    ROOT: '/reports',
    DASHBOARD: '/reports',
    MEMBERS: '/reports/members',
    LOANS: '/reports/loans',
    SAVINGS: '/reports/savings',
    SHARES: '/reports/shares',
    FINANCIAL: '/reports/financial',
    CUSTOM: '/reports/custom',
  },
  
  // Users & Roles Module
  USERS: {
    ROOT: '/users',
    LIST: '/users',
    CREATE: '/users/create',
    EDIT: '/users/:id/edit',
    PROFILE: '/users/:id',
    ROLES: '/users/roles',
    PERMISSIONS: '/users/permissions',
  },
  
  // Settings Module
  SETTINGS: {
    ROOT: '/settings',
    GENERAL: '/settings/general',
    ORGANIZATION: '/settings/organization',
    FINANCIAL: '/settings/financial',
    LOAN_SETTINGS: '/settings/loan',
    SAVINGS_SETTINGS: '/settings/savings',
    EMAIL: '/settings/email',
    SMS: '/settings/sms',
    BACKUP: '/settings/backup',
    AUDIT_LOG: '/settings/audit-log',
  },
  
  // Notifications
  NOTIFICATIONS: '/notifications',
  
  // Profile
  PROFILE: '/profile',
  
  // Catch-all
  NOT_FOUND: '*',
};

/**
 * Route helper functions
 */
export const routeHelpers = {
  // Generate member edit route
  memberEdit: (id) => `/members/${id}/edit`,
  
  // Generate member profile route
  memberProfile: (id) => `/members/${id}`,
  
  // Generate member documents route
  memberDocuments: (id) => `/members/${id}/documents`,
  
  // Generate loan edit route
  loanEdit: (id) => `/loans/${id}/edit`,
  
  // Generate loan details route
  loanDetails: (id) => `/loans/${id}`,
  
  // Generate user edit route
  userEdit: (id) => `/users/${id}/edit`,
  
  // Generate user profile route
  userProfile: (id) => `/users/${id}`,
};

export default ROUTES;
